__turbopack_context__.v({
  "header": "Layout-module-scss-module__vFCYxq__header",
  "outerContainer": "Layout-module-scss-module__vFCYxq__outerContainer",
  "successWrapper": "Layout-module-scss-module__vFCYxq__successWrapper",
  "successWrapperBg": "Layout-module-scss-module__vFCYxq__successWrapperBg",
  "wrapper": "Layout-module-scss-module__vFCYxq__wrapper",
});
